import { SEPARATOR } from "config";

export const formatGroup = (
  group: string | number | (string | number)[] | null | undefined,
  separator = SEPARATOR
) => {
  if (group === null || group === undefined) {
    return "";
  }
  if (Array.isArray(group)) {
    return group.join(separator);
  }
  return group.toString();
};

export const splitGroup = (g: string) => g.split(SEPARATOR);
